import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const EatTimes = () => {
    const { t } = useTranslation();
    const { pageConfiguration } = useContext(BaseContext);

    const saveAnswers = useSaveAnswers();

    const pageKey = LocalStorageKeys[RoutePath.EatTimes];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const answers: ChoiceType[] = [
        {
            key: '2-less-times',
            value: t('eat-times-option-2-less-times'),
        },
        {
            key: '3-times',
            value: t('eat-times-option-3-times'),
        },
        {
            key: '4-times',
            value: t('eat-times-option-4-times'),
        },
        {
            key: '5-more-times',
            value: t('eat-times-option-5-more-times'),
        },
    ];

    const handleClick = (answer: ChoiceType) => {
        setPageValue(answer.key);

        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('eat-times-title'), value: t(answer.value) },
        });

        pageConfiguration.handleOnPageComplete(answer.key);
    };

    return (
        <>
            <Typography variant={TypographyVariants.h1}>
                {t('eat-times-title')}
            </Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === pageValue}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
